import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import * as React from 'react';

// The loader text size. The camera popup loader draws its own 2px smaller from this value,
// to always well fit the camera popup size that is smaller than the full page loader
export const LOADER_TEXT_FONT_SIZE = 22;

interface FullPageLoaderProps {
  message?: string;
}

export default function FullPageLoader({ message }: FullPageLoaderProps) {
  const style: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  }

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div style={style}>
      <div className="loader" style={{ 
        margin: "auto",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}>
        <Spin indicator={antIcon} size="large" />
        <span style={{ 
          color: 'white', 
          fontSize: LOADER_TEXT_FONT_SIZE, 
          marginTop: '20px',
          fontWeight: 'bold'
        }}>{message || 'Loading...'}</span>
      </div>
    </div>
  );
}
